var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActivate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 380,
    height: 160,
    viewBox: "0 0 380 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7093",
    "data-name": "Rectangle 7093",
    width: 380,
    height: 160,
    transform: "translate(726 220)",
    fill: "#f0e4e4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_8404",
    "data-name": "Rectangle 8404",
    d: "M4.077,0H160.016a4.078,4.078,0,0,1,4.078,4.078V99.241a4.078,4.078,0,0,1-4.078,4.078H4.077A4.077,4.077,0,0,1,0,99.242V4.077A4.077,4.077,0,0,1,4.077,0Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8407",
    "data-name": "Rectangle 8407",
    width: 209.774,
    height: 149.371,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Activate_your_card",
    "data-name": "Activate your card",
    transform: "translate(-726 -220)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35107",
    "data-name": "Group 35107",
    transform: "translate(764.805 42.076)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35226",
    "data-name": "Group 35226",
    transform: "translate(70.15 205.141)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35225",
    "data-name": "Group 35225",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8403",
    "data-name": "Rectangle 8403",
    width: 164.094,
    height: 103.319,
    fill: "#004292"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35875",
    "data-name": "Path 35875",
    d: "M219.593,355.137,115.751,177.566,219.593,0,323.432,177.566Z",
    transform: "translate(-55.141 -245.692)",
    fill: "#0b1622"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35876",
    "data-name": "Path 35876",
    d: "M109.267,128.564A109.268,109.268,0,1,1,0,237.831,109.268,109.268,0,0,1,109.267,128.564",
    transform: "translate(-80.524 -217.5)",
    fill: "#f7931a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35877",
    "data-name": "Path 35877",
    d: "M187.612,270.923a109.391,109.391,0,0,0-64.04-136.26l-7.823,13.383Z",
    transform: "translate(-55.142 -216.162)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8405",
    "data-name": "Rectangle 8405",
    width: 164.094,
    height: 23.073,
    transform: "translate(70.15 219.622)",
    fill: "#0d1621"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8406",
    "data-name": "Rectangle 8406",
    width: 50.499,
    height: 11.213,
    transform: "translate(78.778 258.391)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_35228",
    "data-name": "Group 35228",
    transform: "translate(47.309 184.924)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35227",
    "data-name": "Group 35227",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35878",
    "data-name": "Path 35878",
    d: "M168.568,255.127A29.864,29.864,0,1,1,138.7,225.372a29.81,29.81,0,0,1,29.864,29.755",
    transform: "translate(-33.816 -176.054)",
    fill: "#3d72fc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3312",
    "data-name": "Ellipse 3312",
    cx: 29.864,
    cy: 29.755,
    rx: 29.864,
    ry: 29.755,
    transform: "translate(75.024 49.318)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_35927",
    "data-name": "Path 35927",
    d: "M6.72-2.3a2.842,2.842,0,0,0,1.392-.352A3.791,3.791,0,0,0,9.28-3.7l1.808,1.712A5.368,5.368,0,0,1,9.136-.432,5.675,5.675,0,0,1,6.624.16,6.075,6.075,0,0,1,4.288-.288,5.794,5.794,0,0,1,2.416-1.5a5.668,5.668,0,0,1-1.24-1.824A5.669,5.669,0,0,1,.72-5.6a5.726,5.726,0,0,1,.456-2.28A5.584,5.584,0,0,1,2.424-9.712,5.911,5.911,0,0,1,4.3-10.928a6.015,6.015,0,0,1,2.328-.448,5.877,5.877,0,0,1,2.576.592A5.2,5.2,0,0,1,11.168-9.2L9.312-7.44A3.858,3.858,0,0,0,8.088-8.552a2.977,2.977,0,0,0-1.464-.376,2.89,2.89,0,0,0-1.216.256,3.014,3.014,0,0,0-.968.7A3.182,3.182,0,0,0,3.8-6.92,3.714,3.714,0,0,0,3.568-5.6a3.541,3.541,0,0,0,.24,1.312A3.167,3.167,0,0,0,4.472-3.24a3.045,3.045,0,0,0,1,.688A3.122,3.122,0,0,0,6.72-2.3ZM15.856,0l-4.3-11.2h2.976l2.96,8.336L20.5-11.2H23.36L18.992,0ZM28.368,0l-4.3-11.2H27.04L30-2.864,33.008-11.2h2.864L31.5,0Z",
    transform: "translate(133.571 269.721)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivate);
export default __webpack_public_path__ + "static/media/activate.9396d54454a274426adaca5d9cf98513.svg";
export { ForwardRef as ReactComponent };